import store from '@/store/store';
import GetterTypes from '@/store/constants/getters';

export default {
  getEvents() {
    return Promise.resolve(store.getters[GetterTypes.CACHED_EVENTS]);
  },
  getShowsForEvent(eventId, showMapper = (showData) => showData) {
    return store.$axios.get('get_shows', {
      params: {
        eventId,
      },
    }).then((show) => showMapper(show.data));
  },
};
